import { EventEmitter, Output } from '@angular/core';
import { Component, Input, ElementRef } from '@angular/core';
import { HtmlBase, PropertyData, QueovalItem } from '../../../../models';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-checkboxselect',
  templateUrl: './checkboxselect.component.html',
  styleUrls: ['./checkboxselect.component.css']
})

export class CheckBoxSelectComponent {
  @Input('input') input: PropertyData;
  @Input('parent') parent: ElementRef;

  @Output('inputChange') inputEminter: EventEmitter<PropertyData> = new EventEmitter<PropertyData>();
  public checkChange(e: any, elem: PropertyData): void {
    const check: boolean = e.target.checked;
    const id: string = e.target.id;
    const tag: HtmlBase[] = elem.MainElementList.filter((element: HtmlBase) => element.ID === id);
    if (tag && tag.length === 1) {
      tag[0].Value = check ? '1' : '0';
    }
  }

  public selectChange(value: string): void {
    this.input.MainElementList[1].Value = value;
    this.input.MainElementList[1].SelectOptionsList.forEach((item: QueovalItem) => {
      if (item.Value == value) {
        item.Selected = true;
      } else {
        item.Selected = false;
      }
    })
    this.inputEminter.emit(this.input);
  }
}
